// extracted by mini-css-extract-plugin
export default {"responsiveIframeContainer":"ResponsiveIframeNoScroll_responsiveIframeContainer__yKe-X","responsiveIframe":"ResponsiveIframeNoScroll_responsiveIframe__KkjII"};